var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 4.55998V7.53496C12.8332 8.2758 12.5882 8.89997 12.1507 9.33164C11.719 9.76914 11.0948 10.0141 10.354 10.0141L10.354 11.07C10.354 11.4666 9.91067 11.7058 9.584 11.4841L9.01817 11.1108C9.07067 10.93 9.094 10.7316 9.094 10.5216L9.094 8.14749C9.094 6.95749 8.30067 6.16414 7.11067 6.16414L3.14983 6.16414C3.06817 6.16414 2.99234 6.16999 2.9165 6.17582V4.55998C2.9165 3.07248 3.90817 2.08081 5.39567 2.08081L10.354 2.08081C11.8415 2.08081 12.8332 3.07248 12.8332 4.55998Z",
    stroke: "#797D8A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.094 8.14741V10.5215C9.094 10.7315 9.07068 10.9299 9.01818 11.1107C8.80234 11.9682 8.09067 12.5049 7.11067 12.5049H5.524L3.76234 13.6774C3.49984 13.8582 3.14983 13.6657 3.14983 13.3507V12.5049C2.55483 12.5049 2.05901 12.3066 1.71484 11.9624C1.36484 11.6124 1.1665 11.1165 1.1665 10.5215L1.1665 8.14741C1.1665 7.03908 1.85484 6.27491 2.9165 6.17574C2.99234 6.16991 3.06817 6.16406 3.14983 6.16406L7.11067 6.16406C8.30067 6.16406 9.094 6.95741 9.094 8.14741Z",
    stroke: "#797D8A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMess);
export default __webpack_public_path__ + "static/media/mess.96165d4052350088e25914b93fece7c9.svg";
export { ForwardRef as ReactComponent };